var _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_195_1",
    "data-name": "Component 195 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 44,
    height: 38,
    rx: 4,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "MD",
    transform: "translate(22 25)",
    fill: "#a60086",
    fontSize: 19,
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontWeight: 700,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.124,
    y: 0
  }, "MD"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdMd);
export default __webpack_public_path__ + "static/media/prodMD.f316cbddffdf9df9d0b23351fe71985f.svg";
export { ForwardRef as ReactComponent };